import React from "react";
import Imgs from "../image/images";
import { IoIosArrowDropdown } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import style1 from "./workout.module.css"

const Shoulderworkout = () =>{
    const Fun = () =>{
        var x = document.getElementById("abs");
        var y = document.getElementById("plank");
        x.style.display= "block";
        y.style.position = "absolute";
        y.style.top = "64%"
    }
    const Delete = () =>{
        var y = document.getElementById("abs");
        var x = document.getElementById("plank");
        y.style.display = "none";
        x.style.position = "absolute";
        x.style.top = "50%"
    }
    const Fun1 = () =>{
        var x1 = document.getElementById("crunch");
        var y1 = document.getElementById("crunch1");
        x1.style.display = "block";
        y1.style.position = "absolute";
        y1.style.top = "64%"
    }
    const Delete1 = () =>{
        var y1 = document.getElementById("crunch");
        var x1 = document.getElementById("crunch1");
        y1.style.display = "none";
        x1.style.position = "absolute";
        x1.style.top = "50%"
    }
    const Fun2 = () =>{
        var x1 = document.getElementById("twist");
        var y1 = document.getElementById("crunch2");
        x1.style.display = "block";
        y1.style.position = "absolute";
        y1.style.top = "64%"
    }
    const Delete2 = () =>{
        var x1 = document.getElementById("crunch2");
        var y1 = document.getElementById("twist");
        y1.style.display = "none";
        x1.style.position = "absolute";
        x1.style.top = "50%"
    }
    const Func = () =>{
        var x1 = document.getElementById("p");
        x1.style.display = "block";
        var y = document.getElementById("plank");
        y.style.position = "absolute";
        y.style.top = "45%"
    }
    const Deletec = () =>{
        var y1 = document.getElementById("p");
        y1.style.display = "none";
        var y = document.getElementById("plank");
        y.style.position = "absolute";
        y.style.top = "50%"
    }
    const Func1 = () =>{
        var x1 = document.getElementById("c");
        x1.style.display = "block";
        var y1 = document.getElementById("crunch1");
        y1.style.position = "absolute";
        y1.style.top = "45%"
    }
    const Deletec1 = () =>{
        var y1 = document.getElementById("c");
        y1.style.display = "none";
        var y = document.getElementById("crunch1");
        y.style.position = "absolute";
        y.style.top = "50%"
    }
    const Func2 = () =>{
        var x1 = document.getElementById("c2");
        x1.style.display = "block";
        var y1 = document.getElementById("crunch2");
        y1.style.position = "absolute";
        y1.style.top = "45%"
    }
    const Deletec2 = () =>{
        var y1 = document.getElementById("c2");
        y1.style.display = "none";
        var y = document.getElementById("crunch2");
        y.style.position = "absolute";
        y.style.top = "50%"
    }   
    return (
        <>
            <div className={style1.head1}>
                <h1 className={style1.name}>Shoulders Workout</h1>
                <img src={Imgs.logo} alt="not_found" className={style1.logo}/>
            </div>
            <div className={style1.body1}>
                <div className={style1.ex1}>
                    <p className={style1.p1}>Pike PushUps</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun()}/>
                    <div className={style1.box1}>
                        <img src="https://builtwithscience.com/wp-content/uploads/2020/04/Shoulder-workout-at-home-pike-pushups-1024x575.jpg" alt="" />
                    </div>
                    <div className={style1.video1} id="abs">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete()}/>
                        <video src={Imgs.video15} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex2}>
                    <p className={style1.p2}>Lateral Raises</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun1()}/>
                    <div className={style1.box2}>
                        <img src="https://i.ytimg.com/vi/3VcKaXpzqRo/maxresdefault.jpg" alt="" />
                    </div>
                    <div className={style1.video2} id="crunch">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete1()}/>
                        <video src={Imgs.video16} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex3}>
                    <p className={style1.p3}>Reverse Fly</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun2()}/>
                    <div className={style1.box3}>
                        <img src="https://www.verywellfit.com/thmb/0OLkgM-Hi7TsQE2zN99H2hUDQr4=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/standing-bent-over-dumbbell-reverse-fly-workout-496036282-d31f84b1667845768507505d08c34eea.jpg" alt="" />
                    </div>
                    <div className={style1.video3} id="twist">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete2()}/>
                        <video src={Imgs.video17} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex4} id="plank">
                    <p className={style1.p1}>Arnold Press</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func()}/>
                    <div className={style1.box1}>
                        <img src="https://cdn.prod.website-files.com/63ed08484c069d0492f5b0bc/6655dccf7f8e0b73d7ec930f_6655cf78c7b75f87262939f7_4zpX3KYSW9mvGFVwUhwh83JC-IzHylKRYdG6u1bb08Qd3xTFO0S17kWNhCzIpxZLzwR_SQhmgF5UUNRPp_AqKEuoSF_FU0YYxr9LdAthlaTu08AOnhZSLx7ibdVsMsNhcckOJ64m63BioegdMqlNYN0.png" alt="" />
                    </div>
                    <div className={style1.video1} id="p">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec()}/>
                        <video src={Imgs.video33} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex5} id="crunch1">
                    <p className={style1.p1}>Dumbell Shoulder Press</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func1()}/>
                    <div className={style1.box1}>
                        <img src="https://i.ytimg.com/vi/qEwKCR5JCog/maxresdefault.jpg" alt="" />
                    </div>
                    <div className={style1.video1} id="c">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec1()}/>
                        <video src={Imgs.video34} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex6} id="crunch2">
                    <p className={style1.p1}>Face pull</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func2()}/>
                    <div className={style1.box1}>
                        <img src="https://www.verywellfit.com/thmb/B27cSOEMh_R_mnRMg9Lnn_zgDvo=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/face-pulls-6dc71b049756464486be3204f23d185a.gif" alt="" />
                    </div>
                    <div className={style1.video1} id="c2">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec2()}/>
                        <video src={Imgs.video35} controls width={350} height={200}></video>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Shoulderworkout;